import React from "react";

/**
 * Identifiant WOSH d'un résident (ex. « MG47783 »).
 *
 * Reprend le couple lavande clair / indigo de la pastille d'avatar : le même
 * langage visuel pour deux attributs de la même personne. C'est la référence
 * que le support et la blanchisserie utilisent pour retrouver quelqu'un, donc
 * elle doit se repérer d'un coup d'œil dans une colonne.
 *
 * L'identifiant n'est pas toujours reconstructible depuis la référence de
 * commande : dans ce cas on rend un tiret discret plutôt qu'une pastille vide,
 * qui se lirait comme une donnée présente mais illisible.
 */
const WoshId = ({ value, size, t }) => {
  if (!value) {
    return (
      <span className="mgr-woshid mgr-woshid--empty" title={t ? t("Nog geen WOSH-nummer") : undefined}>
        —
      </span>
    );
  }

  return (
    <span className={`mgr-woshid${size === "sm" ? " mgr-woshid--sm" : ""}`}>{value}</span>
  );
};

export default WoshId;
